import { updatePassword } from "@services/account/security";
import i18n from "@/i18n";
import posthog from "posthog-js";

const state = {
    loading: false
};

const actions = {
    updatePasswordAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        updatePassword(params).then((res) => {
            posthog.capture("password_changed");
            const snackbar = {
                message: i18n.t("message.updatePasswordSuccess"),
                color: "green",
                btnName: "Close",
                status: true,
                timeout: 2000
            };
            commit("UPDATE_SNACKBAR", snackbar, { root: true });
            commit("UPDATE_LOADING", false);
        });
    }
};

const mutations = {
    UPDATE_LOADING(state, data) {
        state.loading = data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
